module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"create-parcel":"Create Parcel","parcel-created":"Parcel created","failed-create-parcel":"Failed to create parcel","parcel-contents":"Parcel Contents","is-tube":"Is Tube?"}}')
  delete Component.options._Ctor
}
